<template>
    <el-drawer 
        :withHeader="false"
        direction="ltr"
        custom-class="left_side_mobile" 
        :visible.sync="menuDrawer"
        size="200px"
        :append-to-body="true">
        <div class="logo_container">
            <img src="../../assets/images/logo/logo.png" alt="">
        </div>
        <el-scrollbar>
            <el-menu background-color="#72246C" text-color="#ccc" active-text-color="#fff" unique-opened :collapse="isCollapse" :collapse-transition="false" :router="true" :default-active="navActiveIndex" :default-openeds="defaultOpeneds" class="menu_vertical">
                <el-menu-item index="/index" @click="jumpToNav('/index')" v-show="userType===1 || userType===0">
                    <router-link to="/index"><i class="el-icon-s-home"></i>
                        <span>首页</span></router-link>
                </el-menu-item>
                <el-menu-item index="/upload" @click="jumpToNav('/upload')">
                    <router-link to="/upload"><i class="el-icon-upload"></i>
                        <span>上传视频</span></router-link>
                </el-menu-item>
                <el-menu-item index="/list" @click="jumpToNav('/list')">
                    <router-link to="/list"><i class="el-icon-s-order"></i>
                        <span>视频列表</span></router-link>
                </el-menu-item>
                 <el-menu-item  index="/account" @click="jumpToNav('/account')">
                    <router-link to="/account"><i class="el-icon-s-tools"></i>
                        <span>账号管理</span></router-link>
                </el-menu-item>
                <!-- <el-menu-item  index="/setting" @click="jumpToNav('/setting')">
                    <router-link to="/setting"><i class="el-icon-s-tools"></i>
                        <span>设置</span></router-link>
                </el-menu-item> -->
            </el-menu>
        </el-scrollbar>
    </el-drawer>
</template>


<script>
export default {
    data(){
        return {
            navActiveIndex:'',
            defaultOpeneds:[],
            menuDrawer:false,
            isCollapse:false,
        }
    },
    created(){
        this.setMenuActive();
    },
    mounted(){
        let that = this;
        this.$Bus.$on('changmenuDrawer',()=>{
            that.menuDrawer=true;
        });
    },
    methods:{
        setMenuActive(){
              this.navActiveIndex = this.getLastUrl() ? this.getLastUrl() : 'index';
        },
        jumpToNav(url){
            this.navActiveIndex = url;
            this.$router.push({path:url});
        }
    },
    props:['userType']
}
</script>